module.exports = "<div class=\"container_news\">\r\n  <div class=\"header_card\">\r\n    <h1> Noticias</h1>\r\n  </div>\r\n  </div>\r\n\r\n"